import React from "react";
import PropTypes from "prop-types";
import { parse } from "qs";

import { STREAM_TYPE, DEFAULT_CARD_HEIGHT } from "config/constants";
import Stream from "stream/containers/Stream";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import SearchStreamHeader from "stream/components/SearchStreamHeader";
import SummaryCard from "cards/containers/SummaryCard";
import NoResults from "stream/components/NoResults";

class SearchStream extends React.Component {
  render() {
    const search = parse(this.props.location.search.slice(1)).q;

    return (
      <React.Fragment>
        <SearchStreamHeader searchTerm={search} />
        <StandardLayout
          main={
            <Stream
              type={STREAM_TYPE.SEARCH}
              lookup={search}
              onlyShowTitleForA11y={true}
              defaultCardHeight={DEFAULT_CARD_HEIGHT.SUMMARY_CARD}
              contentComponent={SummaryCard}
              noResultsComponent={<NoResults lookup={search} />}
              showSaveTag={false}
              disableAnalytics={true}
              disableUrlUpdating={true}
            />
          }
          mainAriaLabel="Stories"
        />
      </React.Fragment>
    );
  }
}

SearchStream.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

export default SearchStream;
